import React from 'react';

const words = ['Influencer Campaigns', 'Brand Partnerships', 'Creator Strategy', 'Social Growth', 'Content Amplification', 'Audience Analytics', 'Campaign ROI', 'Creative Direction', 'Digital Storytelling'];

export default function Marquee() {
  const repeated = [...words, ...words, ...words, ...words];
  return (
    <div style={{ borderTop: '1px solid #1e1e1e', borderBottom: '1px solid #1e1e1e', padding: '18px 0', overflow: 'hidden', background: '#111111' }}>
      <div style={{ display: 'flex', animation: 'marquee 30s linear infinite', width: 'max-content' }}>
        {repeated.map((w, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '28px', padding: '0 36px', whiteSpace: 'nowrap', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.35)' }}>
            <div style={{ width: '5px', height: '5px', borderRadius: '50%', background: 'var(--accent)', flexShrink: 0 }} />
            {w}
          </div>
        ))}
      </div>
    </div>
  );
}
